import { makeRequest } from 'utils/requestLogger';

export default (id,message_id) =>
    makeRequest('delete', `/api/courses/${id}/messages/${message_id}`);



// WEBPACK FOOTER //
// ./src/app/services/courses/deleteChatMessage.js